import type { SVGProps } from 'react';
const SvgAppRegistration = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#app_registration_svg__a)">
      <path d="M14 4h-4v4h4V4ZM8 16H4v4h4v-4ZM8 10H4v4h4v-4ZM8 4H4v4h4V4ZM14 12.42V10h-4v4h2.42L14 12.42ZM20.88 11.29l-1.17-1.17a.41.41 0 0 0-.58 0l-.88.88L20 12.75l.88-.88a.41.41 0 0 0 0-.58ZM11 18.25V20h1.75l6.67-6.67-1.75-1.75L11 18.25ZM20 4h-4v4h4V4Z" />
    </g>
    <defs>
      <clipPath id="app_registration_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgAppRegistration;
